import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Vivek Chary. All rights reserved.</p>
      <div>
        <a href="https://github.com/Vivekchary2607" target="_blank" rel="noreferrer">GitHub</a> |
        <a href="https://www.linkedin.com/in/vivekcharyguduru" target="_blank" rel="noreferrer"> LinkedIn</a> |
        <a href="guduruvivekcharyg34pythonml@gmail.com"> Email</a>
      </div>
    </footer>
  );
}

export default Footer;
